module.exports = __webpack_public_path__ + "img/diy5.fe4b0bb9.png";